import { useContext, useMemo } from 'react';
import { ActiveBrandContext, ActiveBrandDetailsContext, UserBrandsContext } from './UserBrandsContext';

export function useActiveBrandIdentifier() {
  return useContext(ActiveBrandContext);
}

export function useActiveBrandIdentifierNullSafe() {
  const activeBrandIdentifier = useContext(ActiveBrandContext);
  if (!activeBrandIdentifier) {
    throw new Error('No active brand selected');
  }
  return activeBrandIdentifier;
}

export function useActiveBrand() {
  const activeBrandIdentifier = useContext(ActiveBrandContext);
  const userBrands = useContext(UserBrandsContext);

  return useMemo(() => {
    return userBrands.find((brand) => brand.identifier === activeBrandIdentifier) || null;
  }, [activeBrandIdentifier, userBrands]);
}

export function useActiveBrandDetails() {
  return useContext(ActiveBrandDetailsContext);
}

export function useActiveBrandDetailsNullSafe() {
  const activeBrandDetails = useContext(ActiveBrandDetailsContext);
  if (!activeBrandDetails) {
    throw new Error('No active brand details available');
  }
  return activeBrandDetails;
}
